/**
 *
 * history actions
 * @author Chad Watson
 *
 *
 */
export const DOWNLOAD_ERROR_LOG = "app/history/DOWNLOAD_ERROR_LOG";
